export default class News {
    static fromApi(response) {
        var _a, _b, _c, _d, _e;
        const news = new News();
        const translation = (_a = response === null || response === void 0 ? void 0 : response.translations) === null || _a === void 0 ? void 0 : _a[0];
        news.news_title = (_b = translation === null || translation === void 0 ? void 0 : translation.news_title) !== null && _b !== void 0 ? _b : '';
        news.read_more = (_c = translation === null || translation === void 0 ? void 0 : translation.read_more) !== null && _c !== void 0 ? _c : '';
        news.back = (_d = translation === null || translation === void 0 ? void 0 : translation.back) !== null && _d !== void 0 ? _d : '';
        news.no_news_info = (_e = translation === null || translation === void 0 ? void 0 : translation.no_news_info) !== null && _e !== void 0 ? _e : '';
        return news;
    }
}
